<template>
<div>
    <h1 class="mb-8 font-bold text-3xl">My Shops</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="flex-grow mr-4" @reset="reset" onlySearch>
      </search-filter>

        <inertia-link class="btn-primary" :href="route('my-shops.create')">
            <span>Add</span>
            <span class="hidden md:inline"> Shop/Business</span>
        </inertia-link>
    </div>


    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
        <inertia-link class="bg-white overflow-hidden shadow rounded-lg m-2" v-for="shop in shops.data" :key="shop.id" :href="route('my-shops.show', shop.id)">
            <div class="">
                <div class="px-4 py-5 sm:p-6">
                    <h2 class="text-md text-uppercase leading">{{ shop.name }}</h2>
                    <div class="text-sm mt-1 text-gray-400" v-if="!shop.none_tax">GST TIN {{ shop.tin_number }}</div>
                    <div class="text-sm mt-1 text-gray-400">{{ locations[shop.location] }}</div>
                </div>
                <div class="bg-gray-50 px-4 py-4 sm:px-6 flex flex-col md:flex-row content-between">
                    <div v-if="shop.pivot.approved">
                        <span v-if="shop.status === 'approved'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-green-100 text-green-800">Approved</span>
                        <span v-if="shop.status === 'pending'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">Pending</span>
                        <span v-if="shop.status === 'closed'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800">Closed</span>
                    </div>
                    <div v-else>
                      <span v-if="shop.status === 'approved'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">User Approval Pending</span>
                      <span v-if="shop.status === 'pending'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-yellow-100 text-yellow-800">Pending</span>
                      <span v-if="shop.status === 'closed'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-red-100 text-red-800">Closed</span>
                    </div>
                    <!-- Content goes here -->
                    <!-- We use less vertical padding on card footers at all sizes than on headers or body sections -->
                </div>
            </div>
        </inertia-link>
    </div>
</div>
</template>
<script>

import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Customers/Layout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  name: 'MyShops',
  metaInfo: { title: 'My Shops' },
  layout: Layout,
  components: { Icon, SearchFilter },

  props: {
    shops: {
      type: Object,
      required: true
    },
    locations: Object,
    filters: Object
  },

  data() {
    return {
      form: {
        search: this.filters.search,
        status: this.filters.status,
      },
    }
  },

  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    }
  }
}
</script>

<style scoped>

</style>
